import {Directive, Input} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {ControlAccessors, InputModifierService} from "./input-modifier.service";

@Directive({
    selector: '[formGroup][controlName][toUpperCase]',
    host: {
        '(input)': 'onInput($event)'
    }
})
export class ToUppercaseDirective {

    @Input('controlName') controlName: string;
    @Input('formGroup') form: FormGroup;

    constructor(private _inputModifier: InputModifierService) {
    }

    onInput(event) {
        this._inputModifier.transformControlValue<string>(ControlAccessors.forReactiveForm(this.form, this.controlName),
            event, v => v.toUpperCase())
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/input-modifiers/to-uppercase.directive.ts